import { Button } from '@ui/themed';
import { t } from 'i18next';
import Prism from 'prismjs';
import { useMemo } from 'react';
import { useHandlers } from '../../../context/page-context';
import type { I18nPrefix } from '../../../i18n/prefix';
import './code-snippet.css';

const PAGE = 'features:storefront_widgets.pages.storefront_widgets_page' satisfies I18nPrefix;

export function CodeSnippet({ code }: { code: string }) {
  const { notificationHandler } = useHandlers();
  const trimmed = code.trim();

  const highlighted = useMemo(
    // `markup` is one of Prism's core languages, always registered by the base import.
    () => Prism.highlight(trimmed, Prism.languages.markup as Prism.Grammar, 'markup'),
    [trimmed],
  );

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(trimmed);
      notificationHandler.notify(t('notifications:copied'), undefined, 'success');
    } catch {
      notificationHandler.notify(t(`${PAGE}.copy_error`), undefined, 'error');
    }
  }

  return (
    <div className="spark-code-snippet flex flex-col items-start gap-3">
      <pre className="w-full overflow-x-auto rounded-lg p-4 text-xs leading-6">
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: Prism-generated markup from our own static code snippets, not user input */}
        <code dangerouslySetInnerHTML={{ __html: highlighted }} />
      </pre>
      <Button variant="secondary" icon="copy" onClick={() => void handleCopy()}>
        {t(`${PAGE}.copy`)}
      </Button>
    </div>
  );
}
